export default __webpack_public_path__ + "src/docs/packages/bakubung-villas.pdf";